import {Component,Input,Output, OnInit,EventEmitter,ViewChild} from '@angular/core';
//import {ConstructSectionQuesDirective,ConstructLiDirective,IntializeScrollDirective} from  '../../app.taketestdirective';
@Component({
    selector:'deep-blue-footer',
    templateUrl:'app.footer.html'
})
export class DeepBlueFooterComponent{
    @Input() SectionDetailsList: any;
    @Input() TestInfo: any;
    @Input() isActiveIrSection: any;
    @Input() IsScreenPaused:any;
    @Output() ParentFunctionCall = new EventEmitter();
    @Output() ParentSubmitSolution = new EventEmitter();
    @Output() ParentShowSectionInstructionOnEachCompleteSection = new EventEmitter();
    @Output() ParentShowNext = new EventEmitter();
    @Output() ParentSubmitExam = new EventEmitter();
    @Output() ParentOpenHelpLink = new EventEmitter();
    @Output() ParentEndReviewQuestions = new EventEmitter();
    @Output() ParentReviewScreen = new EventEmitter();
    @Output() ParentPauseExam = new EventEmitter();
    
    FunctionCall(arg1, arg2, arg3) {
        var obj = {
            arg1: arg1,
            arg2: arg2,
            arg3: arg3
        }
        this.ParentFunctionCall.emit(obj);
    }
    SubmitSolution(){
    this.ParentSubmitSolution.emit();
    }
    ShowSectionInstructionOnEachCompleteSection(){
    this.ParentShowSectionInstructionOnEachCompleteSection.emit();
    }
    ShowNext(){
    this.ParentShowNext.emit();
    }
    SubmitExam(){
    this.ParentSubmitExam.emit();
    }
    OpenHelpLink(){
    this.ParentOpenHelpLink.emit();
    }
    EndReviewQuestions(){
    this.ParentEndReviewQuestions.emit();
    }
    ReviewScreen(){
    this.ParentReviewScreen.emit();
    }
    PauseExam(){
    this.ParentPauseExam.emit();
    }
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/Footers/DeepBlue/app.footer.ts